import moment from 'moment'

import { OnSchedHelpers }      from '../../utils/OnSchedHelpers'
import { OnSchedResponse }     from '../../OnSchedResponse'
import { OnSchedRest }         from '../../OnSchedRest'
import { OnSchedOnChange } from '../../utils/OnSchedOnChange'


export const AvailabilityElement = element => {
  // new approach will be to create the container, load it
  // then replace the calendar element within the container
  element.params.date = OnSchedHelpers.IsEmpty(element.params.date) ? new Date() : element.params.date;
  element.timerId = null;

  let timezoneName = moment.tz.guess();

  if (element.params.timezoneName) {
    timezoneName = element.params.timezoneName;
  }
  else if (element.params.tzOffset) {
    timezoneName = null;
  }

  let startDate = element.params.date ? new Date(element.params.date) : new Date();

  var html = OnSchedTemplates.availabilityContainer();
  var el = document.getElementById(element.id);
  el.innerHTML = html;

  var elTimezone = document.getElementById('onsched-timezone');
  var elTimezoneBtn = document.getElementById('onsched-timezone-button');
  elTimezoneBtn.onclick = e => toggleTimezoneDropdown(e);
  elTimezone.classList.toggle('loading');

  var toggleTimezoneDropdown = e => {
    if (e.target.dataset.tztoggle !== 'false') {
      elTimezone.classList.toggle('active');
    }
  }
  
  // Now wire up events on the calendar
  el.addEventListener("change", element.onChange);
  el.addEventListener("click", e => {
    element.onClick(e);

    if (elTimezone.classList.contains('active') && 
        !e.target.classList.contains('onsched-timezone-button')) {
      toggleTimezoneDropdown(e);
    }
  });
  
  // initialize the calendar using only the date which is lightening fast
  var elCalendar = document.querySelector(".onsched-calendar");
  elCalendar.innerHTML = OnSchedTemplates.calendarSelectorFromDate(element.params.date, element.onsched.locale);
  var elTimes = document.querySelector(".onsched-available-times");
  elTimes.innerHTML = "";
  var url = OnSchedHelpers.CreateAvailabilityUrl(element.onsched.apiBaseUrl, element.params, startDate, timezoneName);

  // calculate available days to pull when mounting
  url = OnSchedHelpers.AddUrlParam(url, "dayAvailabilityStartDate",
      OnSchedHelpers.CreateDateString(OnSchedHelpers.GetFirstCalendarDate(element.params.date)));
  url = OnSchedHelpers.AddUrlParam(url, "dayAvailability", 100);
  url = OnSchedHelpers.AddUrlParam(url, "firstDayAvailable", "true");
  
  if (element.params.tzOffset) {
    url = OnSchedHelpers.AddUrlParam(url, "tzOffset", element.params.tzOffset);
  }
  // add additional parameters
  if (element.params.interval) url = OnSchedHelpers.AddUrlParam(url, "interval", element.params.interval);

  OnSchedRest.Get(url, function (response) {
    let detail = response;
    elTimezone.classList.toggle('loading');

    el.dispatchEvent(new CustomEvent("getAvailability", { detail }));
    OnSchedResponse.GetAvailability(element, response);
  })
}

export const ConfirmationElement = element => {
  var el = document.getElementById(element.id);
  el.addEventListener("click", element.onClick);
  if (element.params.appointment === null)
      return;
  // render with a template. element.params.appointment object
  el.innerHTML = OnSchedTemplates.confirmation(element.params.appointment);
}
